import React from "react"; 
import OasisClientLogo from "../assets/Oasis_Client_Logo.png"; 
import PELClientLogo from "../assets/PEL_Client_Logo.png"; 

const Clients = () => {
  const clients = [
    {
      id: 1,
      name: "Oasis WFS Pvt Ltd",
      logo: OasisClientLogo, 
      description: "Oasis WFS Pvt Ltd is the Indian affiliate of Oasis WFS, the world leader in design & manufacturing of bottled and drinking water fountains.",
    },
    {
      id: 2,
      name: "PEL",
      logo: PELClientLogo, 
      description: "PEL is an innovative, Irish owned manufacturer of waste reduction equipment, serving customers all over the world, from the heart of Co. Mayo.",
    },

    // Add more clients here
  ];

  return (
    <section id="clients" className="clients py-5">
      <div className="container">
        <div className="text-center mb-5 section-header">
          <span className="badge rounded-pill px-3 py-2 mb-3" 
                style={{background: "var(--chip)", color: "var(--chiptext)"}}>
            Our Clients
          </span>
          <h2 className="display-5 fw-bold mb-3" style={{color: "var(--secondarytext)"}}>
            Trusted by Industry Leaders
          </h2>
          <div className="divider mx-auto mb-4"></div>
          <p className="lead mx-auto" style={{maxWidth: "600px", color: "var(--secondarytext)", opacity: 0.8}}>
            We partner with visionary organizations that are transforming their industries through innovative solutions.
          </p>
        </div>

        <div className="row justify-content-center">
          {clients.map((client) => (
            <div key={client.id} className="col-md-4 mb-4">
              <div className="client-card h-100 p-4 text-center">
                <div className="client-logo mb-4 mx-auto">
                  <img src={client.logo} alt={client.name} />
                </div>
                <h3 className="h4 mb-3" style={{color: "var(--secondarytext)"}}>
                  {client.name}
                </h3>
                <p style={{color: "var(--secondarytext)", opacity: 0.8}}>
                  {client.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .clients {
          background: linear-gradient(to bottom, white 0%, var(--canvas) 100%);
        }
        
        .divider {
          width: 80px; 
          height: 4px; 
          background: var(--primary);
          border-radius: 999px; 
        }
        
        .client-card {
          background: var(--card);
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
          border: 1px solid var(--cardborder);
        }
        
        .client-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }
        
        .client-logo {
          width: 120px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--chip);
          border-radius: 12px;
          overflow: hidden;
        }
        
        .client-logo img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
        
        .client-card:hover .client-logo {
          background: var(--primary);
          transition: all 0.3s ease;
        }
        
        @media (max-width: 768px) {
          .client-logo {
            width: 100px;
            height: 100px;
          }
        }
      `}</style>
    </section>
  );
};

export default Clients;